import { gql, useMutation } from "@apollo/client";

const SAVE_MEDICAL_PRACTITINOR_DEATILS=gql`
mutation SaveMedicalFormPractitionerDetails($clientId: Int, $gpName: String, $gpEmail: String, $gpAddress: String, $gpHouseNumber: String, $gpStreetName: String, $gpCity: String, $gpPostCode: String, $gpMobile: String, $gpPhoneNoCountry: String, $gpCountryCode: String, $token: String) {
    saveMedicalFormPractitionerDetails(clientId: $clientId, gpName: $gpName, gpEmail: $gpEmail, gpAddress: $gpAddress, gpHouseNumber: $gpHouseNumber, gpStreetName: $gpStreetName, gpCity: $gpCity, gpPostCode: $gpPostCode, gpMobile: $gpMobile, gpPhoneNoCountry: $gpPhoneNoCountry, gpCountryCode: $gpCountryCode, token: $token) {
      success
      message
      data {
        id
        prc_name
        prc_email
        prc_address
        prc_house_no
        prc_street_name
        prc_city
        prc_postcode
        prc_mobile
        prc_phone_country
        prc_country_code
      }
    }
  }
`; 

export const SaveMedicalPractitinorDetailAction=()=>{
    const [
        saveMedicalPractitinorDetailResponseFunction,
        saveMedicalPractitinorDetailResponseData
    ]=useMutation(SAVE_MEDICAL_PRACTITINOR_DEATILS)

    const saveMedicalPractitinorDetailQueryData=saveMedicalPractitinorDetailResponseData;

    const initSaveMedicalPractitinorDetailData=(data, successCallback, errorCallback)=>{
        saveMedicalPractitinorDetailResponseFunction({
            variables:data
        }).then((responseData)=>{
            if(responseData.data.saveMedicalFormPractitionerDetails.success){
                successCallback(responseData.data.saveMedicalFormPractitionerDetails)
            }else{
                errorCallback(responseData)
            }
        }).catch((err)=>{
            errorCallback(err)
        })
    }
    return { saveMedicalPractitinorDetailQueryData,initSaveMedicalPractitinorDetailData}
}